<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../api.js';
    import UserStore from '../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Header from '../components/Header.svelte';
    import TopInfo from '../components/TopInfo.svelte';  
    import Locations from '../components/Locations.svelte'; 
    import Preloader from '../components/Preloader.svelte'; 

    let popup = false;


    let locations = $UserStore?.settings?.shipping_settings?.datalogics_update_inventory_locations ?? [];
    if (!Array.isArray(locations)) {
        locations = [];
    }

    if (!locations.length) {        
        popup = true; 
        locations.push({'enabled' : 1})
    }



    let isLoading = false;

    
    onMount(async() => {

        console.log('UserStore',$UserStore)

        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        }        
        
    })

    const handleSubmit =  async () => {

        isLoading = true;

        console.log('locations list',locations)

        let postData = {};

        postData.action = 'w_update_shipping_methods';
        postData.token = $UserStore.data
        postData.datalogics_update_inventory_locations = locations;

        let response = await fetchData(postData);
        if (response.data) {

            $UserStore.settings = response.data;
            localStorage.setItem('user',JSON.stringify($UserStore))     
            
            alert('הנתונים נשמרו בהצלחה')

        }

        isLoading = false;

    }

    
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">

        <TopInfo />   
        
        <div class="dash-list"> 

            {#if popup}
            <div class="fixed top-0 bottom-0 left-0 right-0 m-auto z-50 flex flex-col items-center justify-center bg-black bg-opacity-50">
                <div class="bg-white shadow-lg p-4 relative">
                    <div class="absolute top-[10px] left-[10px] cursor-pointer text-[20px]" on:click={()=> popup = false }>X</div>
                    <h1 class="text-[20px] font-bold mt-[20px]">{$_('locations.popup_locations_title')}</h1>
                    <div>{$_('locations.popup_locations_text')}</div>
                </div>
            </div>
            {/if}
            
            <div class="orders-top">
                <div class="orders-top-up">
                    <h1 class="text-[20px] font-bold">{$_('locations.locations')}</h1>
                    <span on:click={()=> { locations.push({'enabled' : true}); locations = locations; } } class="create_button"><span>{$_('locations.add_location')}</span></span>
                </div>
                <div class="locations_desc">{$_('locations.locations_desc')}</div>
            </div>
            <Locations {locations}/>
            <div class="shipment-flex-button fixed bottom-[20px] z-20 left-0 right-0 m-auto">
                <div class="create_button box-shadow" on:click={ handleSubmit }>{$_('locations.save')}</div>
            </div> 
        </div>
    </div>
</div>
